import React, { useContext } from "react";
import { Switch, Route, } from "react-router-dom";
import { AppStateContext } from "../../app-state";
import { UserManagement } from "./user-management/Index";
import { FullHeader } from "../common/header-and-footer/FullHeader";
import { NavbarBackHome } from "../common/header-and-footer/NavbarBackHome";
import { PersonalInformationProcessing } from "../event-master/articles/PersonalInformationProcessing";
import { Thridparties } from "./third-parties/Index";
import { SiteFooter } from "../common/header-and-footer/SiteFooter";
import { SiteMap } from "./site-map/Index";
import { List } from "./event-management/List";
import { PageNotFound } from "../PageNotFound";
import { Styleguide } from "./styleguide/Styleguide";
import { EventEdit } from "../event-master/edit-event/EventEdit";
import { EventDetail } from "../event-master/detail/EventDetail";
import { Profile } from "./profile/Profile";
import { Form } from "./user-management/Form";
import { TermsAndConditions } from "./terms-and-conditions/Index";
export const SubMaster = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    return (React.createElement("div", { className: "sub-master" },
        React.createElement(FullHeader, null),
        React.createElement(NavbarBackHome, null),
        React.createElement("div", { className: "sub-master-page" },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/cs/sekce/profil/:urlAccountId" },
                    React.createElement(Profile, null)),
                React.createElement(Route, { path: "/cs/sekce/detail-aukce/:urlEventId" },
                    React.createElement(EventDetail, null)),
                React.createElement(Route, { path: "/cs/sekce/software-tretich-stran" },
                    React.createElement(Thridparties, null)),
                React.createElement(Route, { path: "/cs/sekce/souhlas-se-zpracovanim-osobnich-udaju" },
                    React.createElement(PersonalInformationProcessing, null)),
                React.createElement(Route, { path: "/cs/sekce/mapa-stranek" },
                    React.createElement(SiteMap, null)),
                React.createElement(Route, { path: "/cs/sekce/administrator/:urlAccountId" },
                    React.createElement(Form, null)),
                React.createElement(Route, { path: "/cs/sekce/sprava-uzivatelu/:urlRole" },
                    React.createElement(UserManagement, null)),
                React.createElement(Route, { path: "/cs/sekce/aukcni-rad" },
                    React.createElement(TermsAndConditions, null)),
                React.createElement(Route, { path: "/cs/sekce/sprava-aukci/nova" },
                    React.createElement(EventEdit, null)),
                React.createElement(Route, { path: "/cs/sekce/sprava-aukci" },
                    React.createElement(List, null)),
                React.createElement(Route, { path: "/cs/sekce/styleguide" },
                    React.createElement(Styleguide, null)),
                React.createElement(Route, null,
                    React.createElement(PageNotFound, null)))),
        React.createElement(SiteFooter, null)));
};
